// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wZNO","index":"styles_index__1nHyx"};